// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { GalleryWithEnquiryCardFragmentDoc } from './galleryWithEnquiryCard.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../imageSize.fragment.generated';
export const ComponentGalleryWithEnquiryFragmentDoc = `
    fragment componentGalleryWithEnquiry on ComponentGalleryWithEnquiry {
  __typename
  type
  buttonText
  loadMoreButtonText
  modalType
  modalButtonText
  items {
    ...galleryWithEnquiryCard
  }
}
    `;